var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.infoText)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(`${_vm.infoText}`),expression:"`${infoText}`"}]},[_c('img',{staticClass:"info-icon",attrs:{"src":_vm.getInfoIcon()}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }